/**
 * @file Automatically generated by barrelsby.
 */

export * from './calculate-safe-area';
